<template>
  <div :id="idFormulario" class="container-form-domcilios-sinoj">
    <div style="margin-top: 2em;" class="mb-10">
      <div class="d-flex align-items-center justify-content-between" style="margin-bottom: 2em;">
        <!-- FRACCIONAMIENTO FUERA DE CATALOGO -->
        <div v-if="!estaEditando" style="display: flex; align-items: center;">
          <h6 style="margin-right: 0.5em;">Fraccionamiento fuera de Catalogo: </h6>
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <label :class="[fraccionamientoFueraDeCatalogo.mostrar ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="evtFraccFueraDeCatalogo({ estado: true })">
              <input type="radio" name="options" id="radioFueraDeCatalogoSi" autocomplete="off" checked>Si
            </label>
            <label :class="[!fraccionamientoFueraDeCatalogo.mostrar ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="evtFraccFueraDeCatalogo({ estado: false })">
              <input type="radio" name="options" id="radioFueraDeCatalogoNo" autocomplete="off">No
            </label>
          </div>
        </div>
        <!-- VISUALIZAR EN MAPA -->
        <div v-if="!fraccionamientoFueraDeCatalogo.mostrar" style="display: flex; align-items: center;">
          <h6 style="margin-right: 0.5em;">Visualizar mapa: </h6>
          <div class="btn-group btn-group-toggle" data-toggle="buttons">
            <label :class="[visualizarMapaDomicilios ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="visualizarMapaDomicilios = true, herramientaDomicilio = false">
              <input type="radio" name="options" id="radioVisualizarMapaSi" autocomplete="off" checked>Si
            </label>
            <label :class="[!visualizarMapaDomicilios ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="visualizarMapaDomicilios = false, herramientaDomicilio = false, punteroMarcador= false, render_catalogo += 1">
              <input type="radio" name="options" id="radioVisualizarMapaNo" autocomplete="off">No
            </label>
          </div>
        </div>
      </div>
      <div :id="idFormulario + 'formulario-direccion'" class="form-group">
        <div class="d-flex">
          <div style="width: 25%; margin-right: 1em;">
            <h6>Municipio *</h6>
            <C010Municipios class="p-0 m-0"
                            v-on:valorParaElPadre="evtCambioDeMunicipio"
                            :prefijo="enumeraciones.etiquetasDeHTML.Select"
                            :tipo="enumeraciones.tiposDeSelect.Seleccione"
                            :idDelInput="idFormulario + 'TipoMuncipio'"
                            :parametros="{EntidadFederativaId: enumeraciones.pj.entidadesFederativas.Aguascalientes}"
                            :valorDefinido="valorDefinidoMunicipios"
                            :key="valorDefinidoMunicipios + contadorRenderCatalogoMunicipio"></C010Municipios>
          </div>
          <div style="width: 25%; margin-right: 1em;">
            <h6>
              Fraccionamiento *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && ((fraccionamientoFueraDeCatalogo.mostrar) ? !this.cadenaEsVaciaONula(fraccionamientoFueraDeCatalogo.texto) : !this.cadenaEsVaciaONula(nombreFraccionamiento))" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && ((fraccionamientoFueraDeCatalogo.mostrar) ? this.cadenaEsVaciaONula(fraccionamientoFueraDeCatalogo.texto) : this.cadenaEsVaciaONula(nombreFraccionamiento))" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <!-- :key="valorDefinidoFraccionamientos + contadorRenderCatalogo" -->
            <C019Fraccionamientos v-if="!fraccionamientoFueraDeCatalogo.mostrar" class="p-0 m-0"
                                  v-on:valorParaElPadre="cambioTipoFraccionamiento"
                                  :prefijo="enumeraciones.etiquetasDeHTML.Select"
                                  :tipo="enumeraciones.tiposDeSelect.Seleccione"
                                  :idDelInput="idFormulario + 'idSelectFraccionamientos'"
                                  :parametros="parametrosCFraccionamiento"
                                  :valorDefinido="valorDefinidoFraccionamientos"
                                  :key="'K-CAT-FRACC' + contadorRenderCatalogo"
                                  :deshabilitarInput="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)"
                                  :guardarBusquedaEnLocalStorage="true"></C019Fraccionamientos>
            <input v-if="fraccionamientoFueraDeCatalogo.mostrar" v-model="fraccionamientoFueraDeCatalogo.texto" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" type="text" class="form-control"  placeholder="Ingrese el fraccionamiento" />            
          </div>
          <div style="width: 25%; margin-right: 1em;">
            <h6>
              Calle *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(calle)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(calle)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-model="calle" type="text" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" id="pf-calle-creacion" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(calle) ? 'form-control border border-danger' : 'form-control']"  placeholder="Ingrese la calle de la empresa" />            
          </div>
          <div style="width: 25%;  margin-right: 1em;">
            <h6>
              Número exterior *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(numeroExterior)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(numeroExterior)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-model="numeroExterior" type="text" id="numeroExterior-pf-domicilio" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(numeroExterior) ? 'form-control border border-danger' : 'form-control']" v-mask="'######'" placeholder="######" />
          </div>
          <!-- <div style="width: 25%;  margin-right: 1em;">
            <h6>
              Código Postal *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(codigoPostalFraccionamiento)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-if="!fraccionamientoFueraDeCatalogo.mostrar" v-model="codigoPostalFraccionamiento" disabled type="text" :id="idFormulario + 'cp-pf-domicilio'" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento) ? 'form-control border border-danger' : 'form-control']" placeholder="#####" />
            <input v-if="fraccionamientoFueraDeCatalogo.mostrar" v-model="codigoPostalFraccionamiento" type="text" :id="idFormulario + 'cp-pf-domicilio'" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento) ? 'form-control border border-danger' : 'form-control']" placeholder="#####" />
          </div>   
          <div style="width: 25%;">
            <h6>
              ¿Es legal? *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(esLegal)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(esLegal)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>                      
            <select class="form-control" v-model="esLegal">
              <option value="true">Si</option>
              <option value="false">No</option>
            </select>
          </div>  -->         
        </div>
        <div class="d-flex">
          <!-- <div style="width: 25%;  margin-right: 1em;">
            <h6>
              Número exterior *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(numeroExterior)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(numeroExterior)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-model="numeroExterior" type="text" id="numeroExterior-pf-domicilio" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(numeroExterior) ? 'form-control border border-danger' : 'form-control']" v-mask="'######'" placeholder="######" />
          </div> -->
           <div style="width: 25%; margin-right: 1em;">
            <h6>Inf. Adicional de número exterior</h6>
            <input v-model="infoAdicionalNumeroExterior" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" type="text" id="infoAdicional-pf-domicilio" class="form-control" placeholder=""/>
          </div>
          <div style="width: 25%; margin-right: 1em;">
            <h6>Número interior</h6>
            <input v-model="numeroInterior" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" type="text" id="numeroInterior-pf-domicilio" class="form-control" placeholder="numero interior" />
          </div> 
          <div style="width: 25%;  margin-right: 1em;">
            <h6>
              Código Postal *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(codigoPostalFraccionamiento)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-if="!fraccionamientoFueraDeCatalogo.mostrar" v-model="codigoPostalFraccionamiento" disabled type="text" :id="idFormulario + 'cp-pf-domicilio'" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento) ? 'form-control border border-danger' : 'form-control']" placeholder="#####" />
            <input v-if="fraccionamientoFueraDeCatalogo.mostrar" v-model="codigoPostalFraccionamiento" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" type="text" :id="idFormulario + 'cp-pf-domicilio'" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(codigoPostalFraccionamiento) ? 'form-control border border-danger' : 'form-control']" placeholder="#####" />
          </div>   
          <div style="width: 25%;">
            <h6>
              ¿Es legal? *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(esLegal)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(esLegal)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>                      
            <select class="form-control" v-model="esLegal" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)">
              <option value="true">Si</option>
              <option value="false">No</option>
            </select>
          </div>          
          <!-- <div style="width: 25%; margin-right: 1em;">
            <h6>
              Calle *&nbsp;
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && !this.cadenaEsVaciaONula(calle)" class="fas fa-check-circle text-success font-size: 15px;"></i>
              <i v-if="(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(calle)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
            </h6>
            <input v-model="calle" type="text" id="pf-calle-creacion" :class="[(mostrarErrores || visualizarErroresUbicacionEnMapa) && this.cadenaEsVaciaONula(calle) ? 'form-control border border-danger' : 'form-control']"  placeholder="Ingrese la calle de la empresa" />            
          </div> -->
        </div>
        <div class="mt-1" :class="[(this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId) || fraccionamientoFueraDeCatalogo.mostrar) ? '' : 'deshabilitarSeccion']">
          <h6 class="mt-4" style="width: 100%;">Información adicional</h6>
          <textarea v-model="informacionAdicional" type="text" :disabled="!this.campoRequeridoEsValido(parametrosCFraccionamiento.municipioId)" rows="3" id="descripcion_contenido" class="form-control" placeholder="Ingrese informacion adicional acerca del domicilio" />
        </div>     
      </div>
      <div class="d-flex">
        <div id="contenedor-herramientas" v-if="visualizarMapaDomicilios && (herramientas.domicilioConPuntero || herramientas.ubicarDomicilioEnMapa)" class="acciones-mapa-domicilios">
          <h6>Herramientas</h6>
          <hr />
          <button v-if="!punteroMarcador && herramientas.domicilioConPuntero" type="button" @click="agregarDomicilioEnMapa" class="btn-xs btn-primary text-left"><i class="fas fa-map-marker-alt"></i>&nbsp;&nbsp;Seleccionar domicilio</button>
          <button v-if="punteroMarcador && herramientas.domicilioConPuntero" type="button" @click="mapaModoVisualizacion" class="btn-xs btn-primary text-left"><i class="fas fa-chevron-circle-left"></i>&nbsp;&nbsp;Modo visualización</button>
          <button type="button" @click="visualizarDomicilioEnMapa" class="btn-xs btn-primary mt-1 text-left"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Ubicar domicilio</button>
          <div v-if="herramientaDomicilio && herramientas.ubicarDomicilioEnMapa" class="contenedor-ver-direccionCompleta">
            <label>{{obtenerDomicilioCompleto()}}</label>
          </div>
        </div>
        <div v-if="visualizarMapaDomicilios" id="contenedor-mapa">
          <CMapaDeDomicilios :ref="'mapaDomiciliosFormulario' + idFormulario"
                             :idMapa="idFormulario + MAPA_DOMICILIOS"
                             v-on:cambioDeDatosDomicilioMarcador="asignarValoresDeDomicilio($event)"
                             v-on:cambioDeDatosDomicilioTexto=" datosGeocode = $event"
                             :posicionOrigenMapa="posicionOrigenMapa"
                             :acercamientoInicialMapa="acercamientoInicialMapa"></CMapaDeDomicilios>
        </div>
      </div>
    </div>
    <div :class="[domiciliosTabla.length > 0 ? 'd-flex d-flex justify-content-between mt-2' : 'text-right mt-2']">
      <div class="col-6 p-0">
        <CTablaGenericaCedulas v-show="domiciliosTabla.length > 0"
                               :ref="'ref' + idFormulario + ID_TABLA_DOMICILIOS"
                               :idDelInput="idFormulario + ID_TABLA_DOMICILIOS"
                               :encabezadosColumnas="encabezadosColumnas"
                               :accionesEnTabla="TABLA_DOMICILIOS_ACCIONES"
                               :listaDeCedulas="domiciliosTabla"
                               v-on:accionRadioSeleccionado="domicilioSeleccionado"
                               v-on:accionFuncionEliminar="evtRemoverDomicilioTabla"
                               v-on:accionesFuncionDeEditar="evtEditarDomicilio"></CTablaGenericaCedulas>
      </div>
      <div :class="[estaEditando ? 'd-flex d-flex justify-content-end' : '']">        
        <div><button type="button" @click="agregarDomicilioALista" class="btn btn-primary"><i :class="[estaEditando ? 'fas fa-save' : 'fas fa-plus-square']"></i>&nbsp;&nbsp;{{textoBotonGuardarOEditar}}</button></div>
      </div>
    </div>
  </div>
</template>
<script>
import CMapaDeDomicilios from '../Comun/CMapaDeDomicilios.vue'
import CTablaGenericaCedulas from '../Comun/CTablaGenericaCedulas.vue'
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import * as esri_geo from 'esri-leaflet-geocoder';
import VueMask from 'v-mask'

Vue.use(VueMask);
export default {
     components: {
        CMapaDeDomicilios: CMapaDeDomicilios,
        C019Fraccionamientos: catalogos.SINOJ.C019Fraccionamientos,
        CTablaGenericaCedulas: CTablaGenericaCedulas,
        C010Municipios: catalogos.PJ.C010Municipios
    },
    props: {
        idFormulario: String,
        valorDefinidoFraccionamientos: Number,
        contadorRenderCatalogo: Number,
        valorDefinidoMunicipios: Number,
        contadorRenderCatalogoMunicipio: Number,
        // herramientas actuales = {domicilioConPuntero, ubicarDomicilioEnMapa}
        herramientas: Object,
        conMensajeProcesoAgregar: {
          type: Boolean,
          default: true
        },
        conSeleccionUnicaDeDomicilio: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            enumeraciones,
            datosUbicacion: null,
            visualizarMapaDomicilios: false,
            MAPA_DOMICILIOS: 'mapa-domicilios',
            datosGeocode: null,
            herramientaDomicilio: false,
            posicionOrigenMapa: [21.878305650330997,-102.29601653410975],
            acercamientoInicialMapa: 14,
            punteroMarcador: false,
            municipio: 'Aguascalientes',
            municipioSeleccionado: null,
            ID_TABLA_DOMICILIOS: 'TablaDeDomicilios',
            encabezadosColumnas: ['#','Domicilio',''],
            parametrosCFraccionamiento: {fraccionamientoId: null, municipioId: null, conInactivos: false},
            TABLA_DOMICILIOS_ACCIONES: {motrarAcciones: true,check: false, eliminar: true, editar: true,imprimir: false, ver: false},
            fraccionamientoObj: null,
            /* visualizarCFraccionamientos: false, */
            geocodeSearch: null,
            visualizarErroresUbicacionEnMapa: false,
            nombreFraccionamiento: null,
            codigoPostalFraccionamiento: null,
            numeroExterior: null,
            numeroInterior: null,
            infoAdicionalNumeroExterior: null,
            calle: null,
            esLegal: null,
            informacionAdicional: null,
            domicilioObj: null,
            mostrarErrores: false,
            contadorDomicilios: 0,
            domicilios: [],
            domiciliosTabla: [],
            domicilioEnEdicion: null,
            textoBotonGuardarOEditar: 'Agregar Domicilio',
            tipoMunicipioId: null,
            estaEditando: false,
            fraccionamientoFueraDeCatalogo: {
              mostrar: false,
              texto: null,
              municipio: null
            }
        }
    },
    methods: {
        seleccionarElementoEnTabla: function() {
          this.$nextTick(() => {
            const REF_TABLA_DOMICILIOS = ('ref' + this.idFormulario + this.ID_TABLA_DOMICILIOS);
            this.$refs[REF_TABLA_DOMICILIOS].seleccionarTodosRadio();
          });
        },
        domicilioSeleccionado: function(domicilio, esParaEdicion = false) { debugger
          console.log('prueba::',domicilio);
          let domicilioObj = (esParaEdicion) ? this.domicilios.find(d => d.idReferencia == domicilio.idReferencia) : this.domicilios.find(d => d.idReferencia == domicilio.Folio);
          this.$emit('domicilioPrincipal', domicilioObj);
        },
        evtFraccFueraDeCatalogo: function({ estado }) {
          this.visualizarMapaDomicilios = false;
          this.herramientaDomicilio = false;
          this.punteroMarcador= false;
          this.render_catalogo += 1;
          this.evtCancelarEdicion();
          this.fraccionamientoFueraDeCatalogo.texto = null;
          this.fraccionamientoFueraDeCatalogo.mostrar = estado;
          this.fraccionamientoFueraDeCatalogo.municipio = null;
          this.codigoPostalFraccionamiento = (estado) ? 2000 : null;
        },
        evtCancelarEdicion: function() {
            this.estaEditando = false;
            this.parametrosCFraccionamiento.municipioId = null;
            this.valorDefinido_fraccionamiento = -1;
            this.render_catalogo ++;
            this.valorDefinido_municipio = -1;
            this.render_catalogo_municipio ++;
            this.textoBotonGuardarOEditar = 'Agregar Domicilio'
            this.domicilioEnEdicion = null;
            this.limpiarDatosDomicilio();
        },
        evtCambioDeMunicipio: function(evento, municipioOBJ) { 
            const TIPO_MUNICIPIO_ID = parseInt(evento.target.value);
            this.municipioObj = municipioOBJ;
            this.parametrosCFraccionamiento.municipioId = TIPO_MUNICIPIO_ID;
            this.valorDefinido_fraccionamiento = -1;
            this.render_catalogo ++;
            this.tipoMunicipioId = TIPO_MUNICIPIO_ID;
            this.limpiarDatosDomicilio();
            this.fraccionamientoFueraDeCatalogo.municipio = evento.target.options[evento.target.selectedIndex].text;
        },
        evtEditarDomicilio: function(evento) { 
            if(!this.estaEditando) {
                const ID_DOMICILIO_SELECCIONADO = this.obtenerIdDomicilioSeleccionado(evento.target.getAttribute('id'));
                let domicilioSeleccionado = null;
                this.domicilios.filter(dobj => dobj.idReferencia == ID_DOMICILIO_SELECCIONADO).forEach(d => {
                    domicilioSeleccionado = d;
                });
                if(domicilioSeleccionado != null) {
                    this.estaEditando = true;
                    this.textoBotonGuardarOEditar = 'Guardar Cambios'
                    this.asignarValoresDomicilioEditar(domicilioSeleccionado);
                    this.mostrarErrores = false;
                }
                this.domicilioEnEdicion = domicilioSeleccionado;
            }
            else {
                comun.mensajeDeAlerta('Actualmente te encuentras editando un domicilio', null, null);
            }
        },
        asignarValoresDomicilioEditar: function(domicilioSeleccionado) { 
            if(domicilioSeleccionado.cpFraccFueraDeCatalogo == null || domicilioSeleccionado.cpFraccFueraDeCatalogo == undefined) {
              //console.log('domicilioSeleccionado::',domicilioSeleccionado);
              this.valorDefinido_municipio = domicilioSeleccionado.Domicilio.Fraccionamiento.Municipio.MunicipioId;
              /* this.valorDefinidoMunicipios = domicilioSeleccionado.Domicilio.Fraccionamiento.Municipio.MunicipioId; */              
              this.render_catalogo_municipio +=2;
              this.parametrosCFraccionamiento.municipioId = domicilioSeleccionado.Domicilio.Fraccionamiento.Municipio.MunicipioId;

              this.fraccionamientoFueraDeCatalogo.mostrar = false;
              this.valorDefinido_fraccionamiento = domicilioSeleccionado.Domicilio.Fraccionamiento.FraccionamientoId;
              /* this.valorDefinidoFraccionamientos = domicilioSeleccionado.Domicilio.Fraccionamiento.FraccionamientoId; */
              this.render_catalogo += 2;
              this.fraccionamientoObj = domicilioSeleccionado.Domicilio.Fraccionamiento;
              this.nombreFraccionamiento = domicilioSeleccionado.Domicilio.Fraccionamiento.Nombre;
              this.codigoPostalFraccionamiento = domicilioSeleccionado.Domicilio.Fraccionamiento.CodigoPostal;
            }
            else {
              //console.log('domicilioSeleccionado::',domicilioSeleccionado);
              this.valorDefinido_municipio = domicilioSeleccionado.idMunicipioFraccFueraDeCatalogo;
              /* this.valorDefinidoMunicipios = domicilioSeleccionado.Domicilio.Fraccionamiento.Municipio.MunicipioId; */              
              this.render_catalogo_municipio +=2;
              this.parametrosCFraccionamiento.municipioId = domicilioSeleccionado.idMunicipioFraccFueraDeCatalogo;
              
              this.visualizarMapaDomicilios = false;
              this.fraccionamientoFueraDeCatalogo.mostrar = true;
              this.valorDefinido_fraccionamiento = -1;
              /* this.valorDefinidoFraccionamientos = domicilioSeleccionado.Domicilio.Fraccionamiento.FraccionamientoId; */
              this.render_catalogo += 2;
              this.fraccionamientoObj = null;
              this.nombreFraccionamiento = domicilioSeleccionado.Domicilio.FraccionamientoFueraDeCatalogo;
              let fraccCompuesto = domicilioSeleccionado.Domicilio.FraccionamientoFueraDeCatalogo.split(',');
              this.fraccionamientoFueraDeCatalogo.texto = fraccCompuesto[0];
              this.codigoPostalFraccionamiento = domicilioSeleccionado.cpFraccFueraDeCatalogo;
            }
            this.esLegal = domicilioSeleccionado.Domicilio.EsLegal ? "true": "false";
            this.numeroExterior = domicilioSeleccionado.Domicilio.NumeroExterior;
            this.numeroInterior = domicilioSeleccionado.Domicilio.NumeroInterior;
            this.infoAdicionalNumeroExterior = domicilioSeleccionado.Domicilio.InformacionAdicionalDeNumeroExterior;
            this.calle = domicilioSeleccionado.Domicilio.Calle;
            this.informacionAdicional = domicilioSeleccionado.Domicilio.Referencias;
            if(this.visualizarMapaDomicilios && !this.fraccionamientoFueraDeCatalogo.mostrar)
                this.visualizarDomicilioEnMapa();
        },
        evtRemoverDomicilioTabla: function(evento) {
            const ID_DOMICILIO_SELECCIONADO = this.obtenerIdDomicilioSeleccionado(evento.target.getAttribute('id'));
            let domicilioSeleccionado = null;
            this.domicilios.filter(dobj => dobj.idReferencia == ID_DOMICILIO_SELECCIONADO).forEach(d => {
                domicilioSeleccionado = d;
            });
            if(domicilioSeleccionado != null)
                this.informarConfirmacionRemoverDomicilio(domicilioSeleccionado);
        },
        obtenerIdDomicilioSeleccionado: function(domicilioSeleccionado) {
            const DOMICILIO = domicilioSeleccionado.split('-');
            const POSICION_DE_ID = (DOMICILIO.length - 1);
            const ID_DOMICILIO = DOMICILIO[POSICION_DE_ID];
            return ID_DOMICILIO;
        },
        asignarValoresDeDomicilio: function(evento) { 
            this.nombreFraccionamiento = evento.address.Neighborhood;
            this.codigoPostalFraccionamiento = evento.address.Postal;
            this.numeroExterior = evento.address.AddNum;
            this.numeroInterior = evento.address.Subregion;            

            if(this.numeroExterior != "") {
                let informacioncalle = evento.address.Address.split(" ");
                let calleC = informacioncalle.slice(0,-1);
                this.calle = calleC.join(" ");
            }
            else {
                this.calle = evento.address.Address;
            }
            this.datosGeocode = evento;
            this.herramientaDomicilio = true;
        },
        mapaModoVisualizacion: function() {
            this.$refs['mapaDomiciliosFormulario' + this.idFormulario].seleccionarDomicilio();
            this.punteroMarcador = false;
        },
        agregarDomicilioEnMapa: function() {
            /* this.visualizarCFraccionamientos = false; */
            this.nombreFraccionamiento = null;
            this.codigoPostalFraccionamiento = null;
            this.$refs['mapaDomiciliosFormulario' + this.idFormulario].seleccionarDomicilio();
            this.punteroMarcador = true;
        },
        cadenaEsVaciaONula: function(campo) {
            /* let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula; */
            let esValido = true
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = false;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = false;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = false;
                }
            }
            return esValido;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        cambioTipoFraccionamiento: function(evento,fraccionamiento) { 
            this.municipioObj = null;
            if(fraccionamiento != null) {
                this.valorDefinido_municipio = fraccionamiento.Municipio.MunicipioId;
                this.valorDefinido_fraccionamiento = fraccionamiento.FraccionamientoId;
                /* this.valorDefinidoMunicipios = fraccionamiento.Municipio.MunicipioId; 
                this.valorDefinidoFraccionamientos = fraccionamiento.FraccionamientoId; */
                this.render_catalogo_municipio ++;
            }
            this.valorDefinido_municipio = (this.cadenaEsVaciaONula(fraccionamiento)) ? -1 : fraccionamiento.Municipio.MunicipioId;
            this.valorDefinido_fraccionamiento = (this.cadenaEsVaciaONula(fraccionamiento)) ? -1 : fraccionamiento.FraccionamientoId;
            /* this.valorDefinidoMunicipios = fraccionamiento.Municipio.MunicipioId; 
            this.valorDefinidoFraccionamientos = fraccionamiento.FraccionamientoId; */
            
            this.limpiarDatosDomicilio();
            

            if(this.visualizarMapaDomicilios) { 
                this.eliminarMarcador();
            }
            this.fraccionamientoObj = fraccionamiento;
            if(this.fraccionamientoObj != null) {
                this.nombreFraccionamiento = this.fraccionamientoObj.Nombre;
                this.codigoPostalFraccionamiento = this.fraccionamientoObj.CodigoPostal.toString();
                /* $("#" + this.idFormulario + 'cp-pf-domicilio').attr('disabled','disabled'); */
            }
            else {
                this.nombreFraccionamiento = null;
                this.codigoPostalFraccionamiento = null;
                this.parametrosCFraccionamiento.municipioId = null;
                this.render_catalogo ++;
                /* $("#" + this.idFormulario + 'cp-pf-domicilio').removeAttr('disabled'); */
            }
           /*  this.$emit('obtenerFraccionamientoFA', this.fraccionamientoObj); */
        },
        limpiarDatosDomicilio: function() {
            this.nombreFraccionamiento = null;
            if(!this.fraccionamientoFueraDeCatalogo.mostrar)
              this.codigoPostalFraccionamiento = null;
            this.esLegal = null;
            this.calle = null;
            this.numeroExterior = null;
            this.numeroInterior = null;
            this.infoAdicionalNumeroExterior = null;
            this.informacionAdicional = null;
            this.fraccionamientoFueraDeCatalogo.texto = null;
            this.fraccionamientoFueraDeCatalogo.municipio = null;
        },
        visualizarDomicilioEnMapa: function() { 
           /*  let datosDomicilio = {
                calle: this.pfCalle,
                ciudad: 'Aguascalientes',
                region: 'Aguascalientes',
                codigoPostal: this.pfCodigoPostal
            }
            this.$refs.mapaDomiciliosCreacion.obtenerCoordenadasPorCalle(datosDomicilio); */
            if(this.domicilioValido()) {
                const DOMICILIO_COMPLETO = this.obtenerDomicilioCompleto();
                this.$refs['mapaDomiciliosFormulario' + this.idFormulario].obtenerCoordenadasPorCalleCompleta(DOMICILIO_COMPLETO);
                this.herramientaDomicilio = true;
                this.visualizarErroresUbicacionEnMapa = false;
            }
            else{
                this.visualizarErroresUbicacionEnMapa = true;
                comun.mensajeDeAlerta('La direccion esta incompleta, debes llenar los campos Municipio, Fraccionamiento, Codigo Postal, Numero Exterior y Calle.', null, null);
            }
        },
        domicilioValido: function() {
            let esValido = false;
            let municipioValido = this.parametrosCFraccionamiento.municipioId == null  || this.parametrosCFraccionamiento.municipioId == -1 ? false : true;
            let fraccionamientoValido = (this.fraccionamientoFueraDeCatalogo.mostrar) ? !this.cadenaEsVaciaONula(this.fraccionamientoFueraDeCatalogo.texto) : !this.cadenaEsVaciaONula(this.nombreFraccionamiento);
            if(municipioValido && fraccionamientoValido && !this.cadenaEsVaciaONula(this.codigoPostalFraccionamiento) && !this.cadenaEsVaciaONula(this.numeroExterior) && !this.cadenaEsVaciaONula(this.calle)) {
                esValido = true;
            }
            return esValido;
        },
        obtenerDomicilioCompleto: function() {
            // formato { calle, fraccionamiento,Municipio, codigo postal, MX }  
            let nombreFraccionamiento = (this.fraccionamientoFueraDeCatalogo.mostrar) 
              ? `${ this.fraccionamientoFueraDeCatalogo.texto }, ${ (this.municipioObj != null && this.municipioObj != undefined) ? this.municipioObj.Nombre : this.municipio }`
              : `${ this.nombreFraccionamiento }, ${ this.fraccionamientoObj.Municipio.Nombre }`;

            let infAdicionalNumExt = (this.infoAdicionalNumeroExterior != null && this.infoAdicionalNumeroExterior != undefined && this.infoAdicionalNumeroExterior != '') ? ` ${ this.infoAdicionalNumeroExterior }` : '';          
            let domicilio = this.numeroInterior != null ? `${this.calle} ${this.numeroExterior}${ infAdicionalNumExt } int. ${this.numeroInterior}, ${nombreFraccionamiento}, ${this.codigoPostalFraccionamiento}, MX` : 
                                                          `${this.calle} ${this.numeroExterior}${ infAdicionalNumExt }, ${nombreFraccionamiento}, ${this.codigoPostalFraccionamiento}, MX`;
            return domicilio;
        },
        obtenerDomicilioCompletoParaGeocode: function() {
            // formato { calle, fraccionamiento,Municipio, codigo postal, MX }  
            let nombreFraccionamiento = (this.fraccionamientoFueraDeCatalogo.mostrar) ? this.fraccionamientoFueraDeCatalogo.texto : this.nombreFraccionamiento;            
            let domicilio = this.numeroInterior != null ? `${this.calle} ${this.numeroExterior} int. ${this.numeroInterior}, ${nombreFraccionamiento}, ${this.municipio}, ${this.codigoPostalFraccionamiento}, MX` : 
                                                          `${this.calle} ${this.numeroExterior}, ${nombreFraccionamiento}, ${this.municipio}, ${this.codigoPostalFraccionamiento}, MX`;
            return domicilio;
        },
        eliminarMarcador: function() {
            this.$refs['mapaDomiciliosFormulario' + this.idFormulario].eliminarMarcador();
            if(this.herramientaDomicilio)
                this.$refs['mapaDomiciliosFormulario' + this.idFormulario].setViewMapa(this.posicionOrigenMapa,this.acercamientoInicialMapa);
            this.herramientaDomicilio = false;
        },
        agregarDomicilioALista: function() {             
            this.obtenerCoordenadasPorCalleCompleta();
        },
        obtenerCoordenadasPorCalleCompleta: function() { 
            if(this.domicilioValido()) { 
                let calleCompleta = this.obtenerDomicilioCompletoParaGeocode();                
                this.geocodeSearch.text(calleCompleta).run( (err, results, response) => { debugger
                    if (err) {
                      console.log("error en geocodeSearch");
                        console.log(err);
                        return;
                    }
                    if(results.results.length > 0) {                         
                        //console.log(results);
                        let mensaje = null;
                        this.municipioFraccionamiento = results.results[0].properties.Subregion;                                            
                        let coordenadasDomicilio = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                        let domicilio = null;
                        if(this.domicilioEnEdicion != null) {                            
                            if(this.domicilioEnEdicion.Domicilio.Coordenadas != null && this.domicilioEnEdicion.Domicilio.Coordenadas != undefined 
                            && this.domicilioEnEdicion.Domicilio.Coordenadas.length > 0 && this.domicilioEnEdicion.Domicilio.Coordenadas[0].CoordenadaId > 0){
                              coordenadasDomicilio.CoordenadaId = this.domicilioEnEdicion.Domicilio.Coordenadas[0].CoordenadaId;
                            }
                            domicilio = this.construirObjDomicilio(coordenadasDomicilio)                            
                            const INDEX_DOMICILIO_EDITADO = this.domicilios.findIndex(d => d.idReferencia == this.domicilioEnEdicion.idReferencia);
                            this.domicilios[INDEX_DOMICILIO_EDITADO] = domicilio;
                            this.domiciliosTabla[INDEX_DOMICILIO_EDITADO].domicilio = this.obtenerDomicilioCompleto();
                            
                            this.domicilios[INDEX_DOMICILIO_EDITADO].Domicilio.DomicilioId = this.domicilioEnEdicion.Domicilio.DomicilioId > 0 ? this.domicilioEnEdicion.Domicilio.DomicilioId : null;
                            this.domicilioSeleccionado(this.domicilioEnEdicion, true);
                            this.domicilioEnEdicion = null;
                            
                            this.textoBotonGuardarOEditar = 'Agregar Domicilio';
                            mensaje = 'Los cambios del domicilio se guardaron correctamente';
                        }
                        else {
                            domicilio = this.construirObjDomicilio(coordenadasDomicilio)
                            this.domicilios.push(domicilio);
                            this.domiciliosTabla.push(this.domicilioObjAFormatoTabla(domicilio));
                            mensaje = 'El domicilio se agrego correctamente';
                        }
                        this.$emit('obtenerListadoDeDomicilios', this.domicilios, { accion: 'actualizar', enEdicion: this.estaEditando });
                        this.limpiarDatosDomicilio();
                        this.mostrarErrores = false;
                        this.parametrosCFraccionamiento.municipioId = null;
                        this.valorDefinido_fraccionamiento = -1;
                        this.render_catalogo ++;
                        this.valorDefinido_municipio = -1;
                        this.render_catalogo_municipio ++;
                        this.estaEditando = false;
                        if(this.visualizarMapaDomicilios)
                            this.eliminarMarcador();

                        if(this.conMensajeProcesoAgregar)
                          comun.mensajeDeAlerta(mensaje, null, null);
                    }
                });
            }
            else {
                this.mostrarErrores = true;
                comun.mensajeDeAlerta('La dirección está incompleta, debes llenar los campos Municipio, Fraccionamiento, Código Postal, Numero Exterior y Calle.', null, null);
            }
        },
        domicilioObjAFormatoTabla: function(domicilio) {
            let domicilioFormatoTabla = {
                Folio: domicilio.idReferencia,
                domicilio: this.obtenerDomicilioCompleto()
            }
            return domicilioFormatoTabla;
        },
        construirObjDomicilio: function(coordenadasDeDomicilio) { 
             // * preguntar como es que tiene varias coordenadas
            let coordenada = {
                Latitud: coordenadasDeDomicilio[0],
                Longitud: coordenadasDeDomicilio[1]
            }
            if(coordenadasDeDomicilio.CoordenadaId != undefined)
              coordenada.CoordenadaId = coordenadasDeDomicilio.CoordenadaId;

            let coordenadas = [coordenada];
             // * 
            let domicilioObj = {
                idReferencia: (this.domicilioEnEdicion != null) ? this.domicilioEnEdicion.idReferencia :this.contadorDomicilios += 1,
                cpFraccFueraDeCatalogo: (this.fraccionamientoFueraDeCatalogo.mostrar) ? this.codigoPostalFraccionamiento : null,
                idMunicipioFraccFueraDeCatalogo: this.parametrosCFraccionamiento.municipioId,
                Domicilio: {                    
                    Calle: this.calle,
                    NumeroExterior: this.numeroExterior,
                    NumeroInterior: this.numeroInterior,
                    InformacionAdicionalDeNumeroExterior: this.infoAdicionalNumeroExterior,
                    Referencias: this.informacionAdicional,
                    Fraccionamiento: (this.fraccionamientoFueraDeCatalogo.mostrar) ? this.fraccionamientoFueraDeCatalogo.texto : this.fraccionamientoObj,
                    Persona: null,
                    Empresa: null,
                    Coordenadas: coordenadas,
                    EsLegal: this.esLegal,
                    FraccionamientoFueraDeCatalogo: (this.fraccionamientoFueraDeCatalogo.mostrar) ? (this.fraccionamientoFueraDeCatalogo.texto + ',' + this.fraccionamientoFueraDeCatalogo.municipio) : null
                }
            };
           
            return domicilioObj;
        },
        informarConfirmacionRemoverDomicilio: function (domicilio) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas remover domicilio<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        const INDEX_DOMICILIO_REMOVER = this.domicilios.findIndex(d => d.idReferencia == domicilio.idReferencia);
                        this.removerDomicilio(this.domicilios, INDEX_DOMICILIO_REMOVER);
                        this.removerDomicilio(this.domiciliosTabla, INDEX_DOMICILIO_REMOVER);
                        if(this.domicilioEnEdicion != null && this.domicilioEnEdicion.idReferencia == domicilio.idReferencia) {
                            this.limpiarDatosDomicilio();
                            this.mostrarErrores = false;
                            this.estaEditando = false;
                            this.parametrosCFraccionamiento.municipioId = null;
                            this.valorDefinido_fraccionamiento = -1;
                            this.render_catalogo ++;
                            this.valorDefinido_municipio = -1;
                            this.render_catalogo_municipio ++;
                            this.domicilioEnEdicion = null;
                            this.textoBotonGuardarOEditar = 'Agregar Domicilio';
                            if(this.visualizarMapaDomicilios)
                                this.eliminarMarcador();
                        }
                        if(this.domiciliosTabla.length < 1)
                            this.contadorDomicilios = 0;
                        this.$emit('obtenerListadoDeDomicilios', this.domicilios, { accion: 'remover', enEdicion: false });
                    }
                }
            });
        },
        removerDomicilio: function(removerEn, indexDomicilioRemover) {
            removerEn.splice(indexDomicilioRemover,1);
        },
        cargarDomiciliosGuardados: function(domicilios, emitirEvento = true){  debugger
          this.$nextTick(() => {
            domicilios.forEach(element => {       debugger
              let domicilioCompleto = "";
              console.log(element);
              if(element.Fraccionamiento != undefined && element.Fraccionamiento != null)  {   
                domicilioCompleto = `${element.Calle} ${element.NumeroExterior} ${ element.NumeroInterior != null ? element.NumeroInterior : "" }, ${element.Fraccionamiento.Nombre}, ${element.Fraccionamiento.Municipio.Nombre}, ${element.Fraccionamiento.CodigoPostal}, MEX`;            
              }else{
                this.domicilioConFraccionamientoFueraDeCatalogo = true;
                let fraccionamientoCompuesto = element.FraccionamientoFueraDeCatalogo.split(',');
                let nombreFraccionamiento = fraccionamientoCompuesto[0];
                let nombreMunicipio = fraccionamientoCompuesto[1];
                domicilioCompleto = `${ element.Calle } #${ element.NumeroExterior }${ element.InformacionAdicionalDeNumeroExterior != null ? element.InformacionAdicionalDeNumeroExterior : "" } ${ element.NumeroInterior != null ? element.NumeroInterior : "" }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
              } 

              this.geocodeSearch.text(domicilioCompleto).run( (err, results, response) => { 
                if (err) {
                  console.log(err);
                  return;
                }
                if(results.results.length > 0) {
                  let domicilio = null;
                  let coordenadas = null;
                  /* antes de domicilio unico 07/10/2021
                  if(element.Coordenadas[0].CoordenadaId != null && element.Coordenadas[0].CoordenadaId != undefined && element.Coordenadas[0].CoordenadaId > 0){
                    coordenadas = element.Coordenadas;
                  }else {
                    let coordenadasDeDomicilio = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                    let coordenada = {
                      Latitud: coordenadasDeDomicilio[0],
                      Longitud: coordenadasDeDomicilio[1]
                    }
                    coordenadas = [coordenada];
                  } */

                  if(element.Coordenadas != null && element.Coordenadas != undefined && element.Coordenadas.length > 0) {
                    if(element.Coordenadas[0].CoordenadaId != null && element.Coordenadas[0].CoordenadaId != undefined && element.Coordenadas[0].CoordenadaId > 0){
                      coordenadas = element.Coordenadas;
                    }else {
                      let coordenadasDeDomicilio = [results.results[0].latlng.lat, results.results[0].latlng.lng];
                      let coordenada = {
                        Latitud: coordenadasDeDomicilio[0],
                        Longitud: coordenadasDeDomicilio[1]
                      }
                      coordenadas = [coordenada];
                    }
                  }

                  domicilio = {
                    idReferencia: (this.domicilioEnEdicion != null) ? this.domicilioEnEdicion.idReferencia :this.contadorDomicilios += 1,
                    Domicilio: {
                      DomicilioId: element.DomicilioId,
                      Calle: element.Calle,
                      NumeroExterior: element.NumeroExterior,
                      NumeroInterior: element.NumeroInterior,
                      InformacionAdicional: element.InformacionAdicional,
                      Referencias: element.Referencias,
                      Fraccionamiento: element.Fraccionamiento,
                      FraccionamientoFueraDeCatalogo: element.FraccionamientoFueraDeCatalogo,
                      Persona: null,
                      Empresa: null,
                      Coordenadas: coordenadas
                    }
                  }
                
                  this.domicilios.push(domicilio);
                  this.domiciliosTabla.push({
                    Folio: domicilio.idReferencia,
                    domicilio: domicilioCompleto
                  });
                  if(!emitirEvento) {
                    this.seleccionarElementoEnTabla();
                    this.$emit('domicilioPrincipal', domicilio);
                  }
                }
              })
            });
          });

          /* Nota: se agrego el parametro emitirEvento para el componente de creacion de cedula, al momento de guardar un domicilio emite el evento para mostrar confirmacion
              para guardar domicilio en base de datos pero en el caso de la edicion no se necesita guardar domicilio solo agregarlo en la tabla
           */
          const ACCION = (emitirEvento) ? 'actualizar' : 'remover';
          this.$emit('obtenerListadoDeDomicilios', this.domicilios, { accion: ACCION, enEdicion: false });
        },
        limpiarDomiciliosTablas: function(){ 
          this.domicilios = [];
          this.domiciliosTabla = [];
          this.contadorDomicilios = 0;
        }
    },
    mounted() {
        $("#" + this.idFormulario + "formulario-direccion input").on("change paste keyup", () => {
            if(this.visualizarMapaDomicilios) {
                this.eliminarMarcador();
            }
        });
        this.geocodeSearch  = esri_geo.geocode();
    },
    created() {
      if(this.conSeleccionUnicaDeDomicilio) {
        this.TABLA_DOMICILIOS_ACCIONES.radio = true;
        this.encabezadosColumnas.push('')
      }
    },
    computed: {
        render_catalogo: {
            get() {
                return this.contadorRenderCatalogo;
            },
            set(val) {
                this.$emit('obtenerContRenderC', val);
            }
        },
        valorDefinido_fraccionamiento: {
            get() {
                return this.valorDefinidoFraccionamientos;
            },
            set(val) {
                this.$emit('obtenerValorDefinidoCF', val);
            }
        },
        render_catalogo_municipio: {
            get() {
                return this.contadorRenderCatalogoMunicipio;
            },
            set(val) {
                this.$emit('obtenerContRenderCM', val);
            }
        },
        valorDefinido_municipio: {
            get() {
                return this.valorDefinidoMunicipios;
            },
            set(val) {
                this.$emit('obtenerValorDefinidoCM', val);
            }
        }
    },
    watch: {
        domiciliosTabla() {
            if(this.domiciliosTabla.length > 1) {
                this.$refs['ref' + this.idFormulario + this.ID_TABLA_DOMICILIOS].cedulasAmostrarPorPagina = 2;
            }
        },
        estaEditando() {
        }
    }
}
</script>
<style scoped>
  .deshabilitarSeccion {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }

  .contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
  }

  @media screen and (max-width: 1380px) {
    #contenedor-herramientas .btn-xs {
      font-size: 12px !important;
    }
  }

  @media screen and (max-width: 1340px) {
    #contenedor-herramientas .btn-xs {
      font-size: 9px !important;
    }
  }

  textarea {
    padding: 0.6em !important;
  }

  #formulario-direccion {
    margin-top: 1em;
    display: flex;
    flex-wrap: wrap;
  }

  .btn-primary:hover {
    color: white;
    background-color: black;
    border-color: white;
  }

  .btn-primary:focus {
    color: white;
    background-color: black;
    border-color: white;
    box-shadow: none;
    ;
  }

  .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
  }

  .btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
  }

    .btn-secondary:hover {
      color: white;
      background-color: #323335;
      border-color: white;
    }

  #contenedor-mapa {
    height: 410px;
    width: 80%;
    margin-left: 1em;
  }

  .acciones-mapa-domicilios {
    background-color: var(--gris-pj);
    padding: 10px;
    width: 20%;
    border: 3px solid #272729;
  }

 .btn-primary {
    background-color: var(--verde-pj-100);
  }

  .btn-xs {
    color: white;
    background-color: rgb(32, 31, 31);
    border-color: white;
    width: 100%;
    height: 40px;
    cursor: pointer;
  }

  .contenedor-ver-direccionCompleta {
    color: white;
    background-color: rgb(32, 31, 31);
    border-color: white;
    width: 100%;
    height: 100px;
    margin-top: 30%;
    padding: 1em;
    border: 1px solid white;
  }

  .container-form-domcilios-sinoj h6 {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CFormularioDomicilio.vue